/*
 *
 * TerminalsManagement Actions
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 10-Dec-2024
 */

import { createAction, createRequestTypes, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_UPDATE_TERMINAL_CONFIG: '@@TerminalsManagement/update_terminal_config',
  DO_SELECT_TERMINAL: '@@TerminalsManagement/select_terminal',
  DO_SET_SELECTED_TERMINAL_ID: '@@TerminalsManagement/set_selected_terminal_id',
  DO_FETCH_TERMINAL_ID_LIST: '@@TerminalsManagement/fetch_terminal_id_list',
  DO_GET_API_KEY_LIST: '@@TerminalsManagement/get_api_key_list',
  DO_CREATE_API_KEY: '@@TerminalsManagement/create_api_key',
  DO_SHOW_API_KEY: '@@TerminalsManagement/show_api_key',
  DO_SET_SHOW_ELEMENTS: '@@TerminalsManagement/set_show_elements',
  DO_DELETE_API_KEY: '@@TerminalsManagement/delete_api_key',
  DO_FETCH_APM_LIST: '@@TerminalsManagement/fetch_apm_list',
  DO_UPDATE_APM: '@@TerminalsManagement/update_apm',
  DO_GET_PAYPAL_EXTERNAL_LINK: '@@TerminalsManagement/get_paypal_external_link',
  DO_UPDATE_PAYPAL_ONBOARDING: '@@TerminalsManagement/update_paypal_onboarding',
  DO_RESET_PAYPAL_EXTERNAL_LINK: '@@TerminalsManagement/reset_paypal_external_url',
  DO_SET_SELECTED_APM_ID: '@@TerminalsManagement/set_selected_apm',
  DO_RETRIEVE_PROCESSING_RULES: '@@TerminalsManagement/retrieve_processing_rules',
  DO_DELETE_PROCESSING_RULES: '@@TerminalsManagement/delete_processing_rules',
  DO_CREATE_PROCESSING_RULES: '@@TerminalsManagement/create_processing_rules',
  DO_SET_SELECTED_RULE: '@@TerminalsManagement/set_selected_rule',
  DO_FETCH_VAS_LIST: '@@TerminalsManagement/fetch_vas_list',
  DO_SET_SELECTED_VAS: '@@TerminalsManagement/set_selected_vas',
  DO_UPDATE_VAS: '@@TerminalsManagement/update_vas',
  DO_RESET_SHOW_API_KEY: '@@TerminalsManagement/reset_show_api_key',
  DO_SET_DISPUTELESS_ACTIVATION_STEP: '@@TerminalsManagement/set_disputeless_activation_step',
  DO_FETCH_STRUCTURES: '@@TerminalsManagement/fetch_structures',
  DO_SET_DISPUTELESS_STATUS: '@@TerminalsManagement/set_disputeless_status',
  DO_FETCH_TACS: '@@TerminalsManagement/fetch_tacs',
  DO_CREATE_TAC: '@@TerminalsManagement/create_tac',
  DO_CREATE_STRUCTURE: '@@TerminalsManagement/create_structure',
  DO_DISPUTELESS_ACTION_CLICK: '@@TerminalsManagement/disputeless_action_click',
  DO_DELETE_TAC: '@@TerminalsManagement/delete_tac',
  DO_DOWNLOAD_TAC_PDF: '@@TerminalsManagement/download_tac_pdf',
  DO_MODIFY_STRUCTURE: '@@TerminalsManagement/modify_structure',
  DO_FETCH_RESERVATION_TYPES: '@@TerminalsManagement/fetch_reservation_types',
  DO_FIND_STRUCTURE_DETAILS: '@@TerminalsManagement/find_structure_details',
  DO_RETRIEVE_TERMS_AND_CONDITIONS: '@@TerminalsManagement/retrieve_terms_and_conditions',
  DO_SET_SINGLE_TERMINAL_STATUS: '@@TerminalsManagement/set_single_terminal_status',
  DO_FETCH_POS_TOKENIZATION_TERMINALS: '@@TerminalsManagement/fetch_pos_tokenization_terminals',
  DO_SET_FILTER_COUNT: '@@TerminalsManagement/set_filter_count',
  DO_SHOW_POS_TOKENIZATION_FILTERS: '@@TerminalsManagement/show_pos_tokenization_filters',
  DO_SET_ACTIVE_TAB_INDEX: '@@TerminalsManagement/set_active_tab_index',
  // @generator action:route:type
  ...createRequestTypes('@@TerminalsManagement', 'UPDATE_TERMINAL_CONFIG'),
  ...createRequestTypes('@@TerminalsManagement', 'RETRIEVE_API_KEY_LIST'),
  ...createRequestTypes('@@TerminalsManagement', 'RETRIEVE_API_KEY_CREATED'),
  ...createRequestTypes('@@TerminalsManagement', 'RETRIEVE_SHOW_API_KEY'),
  ...createRequestTypes('@@TerminalsManagement', 'RETRIEVE_DELETE_API_KEY'),
  ...createRequestTypes('@@TerminalsManagement', 'GET_APM_LIST'),
  ...createRequestTypes('@@TerminalsManagement', 'UPDATE_APM'),
  ...createRequestTypes('@@TerminalsManagement', 'GET_PAYPAL_EXTERNAL_LINK'),
  ...createRequestTypes('@@TerminalsManagement', 'POST_PAYPAL_ONBOARDING'),
  ...createRequestTypes('@@TerminalsManagement', 'UPDATE_TERMINAL_CONFIG'),
  ...createRequestTypes('@@TerminalsManagement', 'RETRIEVE_PROCESSING_RULES'),
  ...createRequestTypes('@@TerminalsManagement', 'DELETE_PROCESSING_RULES'),
  ...createRequestTypes('@@TerminalsManagement', 'CREATE_PROCESSING_RULES'),
  ...createRequestTypes('@@TerminalsManagement', 'FETCH_VAS_LIST'),
  ...createRequestTypes('@@TerminalsManagement', 'UPDATE_VAS'),
  ...createRequestTypes('@@TerminalsManagement', 'FETCH_STRUCTURES'),
  ...createRequestTypes('@@TerminalsManagement', 'SET_DISPUTELESS_STATUS'),
  ...createRequestTypes('@@TerminalsManagement', 'FETCH_TACS'),
  ...createRequestTypes('@@TerminalsManagement', 'CREATE_TAC'),
  ...createRequestTypes('@@TerminalsManagement', 'CREATE_STRUCTURE'),
  ...createRequestTypes('@@TerminalsManagement', 'MODIFY_TAC'),
  ...createRequestTypes('@@TerminalsManagement', 'RETRIEVE_TAC_PDF'),
  ...createRequestTypes('@@TerminalsManagement', 'MODIFY_STRUCTURE'),
  ...createRequestTypes('@@TerminalsManagement', 'FETCH_RESERVATION_TYPES'),
  ...createRequestTypes('@@TerminalsManagement', 'FIND_STRUCTURE_DETAILS'),
  ...createRequestTypes('@@TerminalsManagement', 'RETRIEVE_TERMS_AND_CONDITIONS'),
  ...createRequestTypes('@@TerminalsManagement', 'RETRIEVE_POS_TOKENIZATION_TERMINALS'),
  ...createRequestTypes('@@TerminalsManagement', 'SET_POS_TOKENIZATION_STATUS')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name setPosTokenizationStatus
 * @return {object} - The action object
 */
export const setPosTokenizationStatus = new MakeRequest('TerminalsManagement', 'set_pos_tokenization_status')
/** @action request
 * * Insert a description
 * @name retrievePosTokenizationTerminals
 * @return {object} - The action object
 */
export const retrievePosTokenizationTerminals = new MakeRequest(
  'TerminalsManagement',
  'retrieve_pos_tokenization_terminals'
)
/** @action request
 * * Insert a description
 * @name retrieveTermsAndConditions
 * @return {object} - The action object
 */
export const retrieveTermsAndConditions = new MakeRequest('TerminalsManagement', 'retrieve_terms_and_conditions')
/** @action request
 * * Insert a description
 * @name findStructureDetails
 * @return {object} - The action object
 */
export const findStructureDetails = new MakeRequest('TerminalsManagement', 'find_structure_details')
/** @action request
 * * Insert a description
 * @name fetchReservationTypes
 * @return {object} - The action object
 */
export const fetchReservationTypes = new MakeRequest('TerminalsManagement', 'fetch_reservation_types')
/** @action request
 * * Insert a description
 * @name modifyStructure
 * @return {object} - The action object
 */
export const modifyStructure = new MakeRequest('TerminalsManagement', 'modify_structure')
/** @action request
 * * Insert a description
 * @name retrieveTacPdf
 * @return {object} - The action object
 */
export const retrieveTacPdf = new MakeRequest('TerminalsManagement', 'retrieve_tac_pdf')
/** @action request
 * * Insert a description
 * @name modifyTac
 * @return {object} - The action object
 */
export const modifyTac = new MakeRequest('TerminalsManagement', 'modify_tac')
/** @action request
 * * Insert a description
 * @name createStructure
 * @return {object} - The action object
 */
export const createStructure = new MakeRequest('TerminalsManagement', 'create_structure')
/** @action request
 * * Insert a description
 * @name createTac
 * @return {object} - The action object
 */
export const createTac = new MakeRequest('TerminalsManagement', 'create_tac')
/** @action request
 * * Insert a description
 * @name fetchTacs
 * @return {object} - The action object
 */
export const fetchTacs = new MakeRequest('TerminalsManagement', 'fetch_tacs')


/** @action request
 * * Insert a description
 * @name fetchStructures
 * @return {object} - The action object
 */
export const fetchStructures = new MakeRequest('TerminalsManagement', 'fetch_structures')
/** @action request
 * * Insert a description
 * @name setDisputelessStatus
 * @return {object} - The action object
 */
export const setDisputelessStatus = new MakeRequest('TerminalsManagement', 'set_disputeless_status')
/** @action request
 * * Insert a description
 * @name createOrUpdateUser
 * @return {object} - The action object
 */
export const updateVas = new MakeRequest('TerminalsManagement', 'update_vas')
/** @action request
 * * Insert a description
 * @name retrieveProcessingRules
 * @return {object} - The action object
 */
export const retrieveProcessingRules = new MakeRequest('TerminalsManagement', 'retrieve_processing_rules')
/** @action request
 * * Insert a description
 * @name fetchVasList
 * @return {object} - The action object
 */
export const fetchVasList = new MakeRequest('TerminalsManagement', 'fetch_vas_list')
/** @action request
 * * Insert a description
 * @name retrieveDeleteApiKey
 * @return {object} - The action object
 */
export const retrieveDeleteApiKey = new MakeRequest('TerminalsManagement', 'retrieve_delete_api_key')
/** @action request
 * @name postPaypalOnboarding
 * @return {object} - The action object
 */
export const postPaypalOnboarding = new MakeRequest('TerminalsManagement', 'post_paypal_onboarding')
/** @action request
 * * Insert a description
 * @name getPaypalExternalLink
 * @return {object} - The action object
 */
export const getPaypalExternalLink = new MakeRequest('TerminalsManagement', 'get_paypal_external_link')
/** @action request
 * * Insert a description
 * @name updateApm
 * @return {object} - The action object
 */
export const updateApm = new MakeRequest('TerminalsManagement', 'update_apm')
/** @action request
 * * Insert a description
 * @name getApmList
 * @return {object} - The action object
 */
export const getApmList = new MakeRequest('TerminalsManagement', 'get_apm_list')
/** @action request
 * * Insert a description
 * @name updateTerminalConfig
 * @return {object} - The action object
 */
export const updateTerminalConfig = new MakeRequest('TerminalsManagement', 'update_terminal_config')
/** @action request
 * * Insert a description
 * @name DeleteProcessingRules
 * @return {object} - The action object
 */
export const deleteProcessingRules = new MakeRequest('TerminalsManagement', 'delete_processing_rules')
/** @action request
 * * Insert a description
 * @name createProcessingRules
 * @return {object} - The action object
 */
export const createProcessingRules = new MakeRequest('TerminalsManagement', 'create_processing_rules')
/** @action request
 * * Insert a description
 * @name retrieveShowApiKey
 * @return {object} - The action object
 */
export const retrieveShowApiKey = new MakeRequest('TerminalsManagement', 'retrieve_show_api_key')
/** @action request
 * * Insert a description
 * @name retrieveApiKeyCreated
 * @return {object} - The action object
 */
export const retrieveApiKeyCreated = new MakeRequest('TerminalsManagement', 'retrieve_api_key_created')
/** @action request
 * * Insert a description
 * @name retrieveApiKeyList
 * @return {object} - The action object
 */
export const retrieveApiKeyList = new MakeRequest('TerminalsManagement', 'retrieve_api_key_list')
// @generator action:route
/** @action
 * * Insert a description
 * @name SetActiveTabIndex
 * @return {object} - The payload object
 */
export const doSetActiveTabIndex = (payload) => createAction(actionTypes.DO_SET_ACTIVE_TAB_INDEX, { payload })
/** @action
 * * Insert a description
 * @name SetSingleTerminalStatus
 * @return {object} - The payload object
 */
export const doSetSingleTerminalStatus = (payload) =>
  createAction(actionTypes.DO_SET_SINGLE_TERMINAL_STATUS, { payload })
/** @action
 * * Insert a description
 * @name ShowPosTokenizationFilters
 * @return {object} - The payload object
 */
export const doShowPosTokenizationFilters = (payload) =>
  createAction(actionTypes.DO_SHOW_POS_TOKENIZATION_FILTERS, { payload })
/** @action
 * * Insert a description
 * @name SetFilterCount
 * @return {object} - The payload object
 */
export const doSetFilterCount = (payload) => createAction(actionTypes.DO_SET_FILTER_COUNT, { payload })

/** @action
 * * Insert a description
 * @name FetchPosTokenizationTerminals
 * @return {object} - The payload object
 */
export const doFetchPosTokenizationTerminals = (payload) =>
  createAction(actionTypes.DO_FETCH_POS_TOKENIZATION_TERMINALS, { payload })
/** @action
 * * Insert a description
 * @name FetchStructures
 * @return {object} - The payload object
 */
export const doFetchStructures = (payload) => createAction(actionTypes.DO_FETCH_STRUCTURES, { payload })
/** @action
 * * Insert a description
 * @name SetDisputelessStatus
 * @return {object} - The payload object
 */
export const doSetDisputelessStatus = (payload) => createAction(actionTypes.DO_SET_DISPUTELESS_STATUS, { payload })
/** @action
 * * Insert a description
 * @name CreateStructure
 * @return {object} - The payload object
 */
export const doCreateStructure = (payload) => createAction(actionTypes.DO_CREATE_STRUCTURE, { payload })
/** @action
 * * Insert a description
 * @name RetrieveTermsAndConditions
 * @return {object} - The payload object
 */
export const doRetrieveTermsAndConditions = (payload) =>
  createAction(actionTypes.DO_RETRIEVE_TERMS_AND_CONDITIONS, { payload })
/** @action
 * * Insert a description
 * @name FindStructureDetails
 * @return {object} - The payload object
 */
export const doFindStructureDetails = (payload) => createAction(actionTypes.DO_FIND_STRUCTURE_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name FetchReservationTypes
 * @return {object} - The payload object
 */
export const doFetchReservationTypes = (payload) => createAction(actionTypes.DO_FETCH_RESERVATION_TYPES, { payload })
/** @action
 * * Insert a description
 * @name ModifyStructure
 * @return {object} - The payload object
 */
export const doModifyStructure = (payload) => createAction(actionTypes.DO_MODIFY_STRUCTURE, { payload })
/** @action
 * * Insert a description
 * @name DownloadTacPdf
 * @return {object} - The payload object
 */
export const doDownloadTacPdf = (payload) => createAction(actionTypes.DO_DOWNLOAD_TAC_PDF, { payload })
/** @action
 * * Insert a description
 * @name DeleteTac
 * @return {object} - The payload object
 */
export const doDeleteTac = (payload) => createAction(actionTypes.DO_DELETE_TAC, { payload })
/** @action
 * @name DisputelessActionClick
 * @return {object} - The payload object
 */
export const doDisputelessActionClick = (payload) => createAction(actionTypes.DO_DISPUTELESS_ACTION_CLICK, { payload })
/** @action
 * * Insert a description
 * @name CreateTac
 * @return {object} - The payload object
 */
export const doCreateTac = (payload) => createAction(actionTypes.DO_CREATE_TAC, { payload })
/** @action
 * * Insert a description
 * @name FetchTacs
 * @return {object} - The payload object
 */
export const doFetchTacs = (payload) => createAction(actionTypes.DO_FETCH_TACS, { payload })

/** @action
 * * Insert a description
 * @name SetDisputelessActivationStep
 * @return {object} - The payload object
 */
export const doSetDisputelessActivationStep = (payload) =>
  createAction(actionTypes.DO_SET_DISPUTELESS_ACTIVATION_STEP, { payload })
/** @action
 * * Insert a description
 * @name SetSelectedRule
 * @return {object} - The payload object
 */
export const doSetSelectedRule = (payload) => createAction(actionTypes.DO_SET_SELECTED_RULE, { payload })
/** @action
 * * Insert a description
 * @name DeleteApiKey
 * @return {object} - The payload object
 */
export const doDeleteApiKey = (payload) => createAction(actionTypes.DO_DELETE_API_KEY, { payload })
/** @action
 * * Insert a description
 * @name SetShowElements
 * @return {object} - The payload object
 */
export const doSetShowElements = (payload) => createAction(actionTypes.DO_SET_SHOW_ELEMENTS, { payload })
/** @action
 * * Insert a description
 * @name SetSelectedAPm
 * @return {object} - The payload object
 */
export const doSetSelectedApmId = (payload) => createAction(actionTypes.DO_SET_SELECTED_APM_ID, { payload })
/** @action
 * * Insert a description
 * @name ResetPaypalExternalLink
 * @return {object} - The payload object
 */
export const doResetPaypalExternalLink = (payload) =>
  createAction(actionTypes.DO_RESET_PAYPAL_EXTERNAL_LINK, { payload })
/** @action
 * * Insert a description
 * @name UpdatePaypalOnboarding
 * @return {object} - The payload object
 */
export const doUpdatePaypalOnboarding = (payload, callback) =>
  createAction(actionTypes.DO_UPDATE_PAYPAL_ONBOARDING, { payload, callback })
/** @action
 * * Insert a description
 * @name GetPaypalExternalLink
 * @return {object} - The payload object
 */
export const doGetPaypalExternalLink = (payload) => createAction(actionTypes.DO_GET_PAYPAL_EXTERNAL_LINK, { payload })
/** @action
 * * Insert a description
 * @name UpdateApm
 * @return {object} - The payload object
 */
export const doUpdateApm = (payload, batchConfig) => createAction(actionTypes.DO_UPDATE_APM, { payload, batchConfig })
/** @action
 * * Insert a description
 * @name FetchApmList
 * @return {object} - The payload object
 */
export const doFetchApmList = (callback) => createAction(actionTypes.DO_FETCH_APM_LIST, { callback })
/** @action
 * * Insert a description
 * @name CreateProcessingRules
 * @return {object} - The payload object
 */
export const doCreateProcessingRules = (payload) => createAction(actionTypes.DO_CREATE_PROCESSING_RULES, { payload })
/** @action
 * * Insert a description
 * @name DeleteProcessingRules
 * @return {object} - The payload object
 */
export const doDeleteProcessingRules = (payload) => createAction(actionTypes.DO_DELETE_PROCESSING_RULES, { payload })
/** @action
 * * Insert a description
 * @name RetrieveProcessingRules
 * @return {object} - The payload object
 */
export const doRetrieveProcessingRules = (payload) =>
  createAction(actionTypes.DO_RETRIEVE_PROCESSING_RULES, { payload })
/** @action
 * * Insert a description
 * @name FetchTerminalIdList
 * @return {object} - The payload object
 */
export const doFetchTerminalIdList = (payload) => createAction(actionTypes.DO_FETCH_TERMINAL_ID_LIST, { payload })
/** @action
 * * Insert a description
 * @name SetTerminal
 * @return {object} - The payload object
 */
export const doSetSelectedTerminalId = (payload) => createAction(actionTypes.DO_SET_SELECTED_TERMINAL_ID, { payload })
/** @action
 * * Insert a description
 * @name UpdateTerminalConfig
 * @return {object} - The payload object
 */
export const doUpdateTerminalConfig = (payload) => createAction(actionTypes.DO_UPDATE_TERMINAL_CONFIG, { payload })
/** @action
 * * Insert a description
 * @name ShowApiKey
 * @return {object} - The payload object
 */
export const doShowApiKey = (payload) => createAction(actionTypes.DO_SHOW_API_KEY, { payload })
/** @action
 * * Insert a description
 * @name CreateApiKey
 * @return {object} - The payload object
 */
export const doCreateApiKey = (payload) => createAction(actionTypes.DO_CREATE_API_KEY, { payload })
/** @action
 * * Insert a description
 * @name GetApiKeyList
 * @return {object} - The payload object
 */
export const doGetApiKeyList = (payload) => createAction(actionTypes.DO_GET_API_KEY_LIST, { payload })
/** @action
 * * Insert a description
 * @name ResetShowApiKeyResult
 * @return {object} - The payload object
 */
export const doResetShowApiKeyResult = (payload) => createAction(actionTypes.DO_RESET_SHOW_API_KEY, { payload })
/** @action
 * * Insert a description
 * @name UpdateVas
 * @return {object} - The payload object
 */
export const doUpdateVas = (payload, callback) => createAction(actionTypes.DO_UPDATE_VAS, { payload, callback })
/** @action
 * * Insert a description
 * @name FetchVasList
 * @return {object} - The payload object
 */
export const doFetchVasList = (payload) => createAction(actionTypes.DO_FETCH_VAS_LIST, { payload })
/** @action
 * * Insert a description
 * @name SetSelectedVas
 * @return {object} - The payload object
 */
export const doSetSelectedVas = (payload) => createAction(actionTypes.DO_SET_SELECTED_VAS, { payload })
